import { gql } from "@apollo/client";

export const getPayoutStatsHistory = gql`
    query payoutStatsHistory($input: PayoutStatsInput!) {
        payoutStats(input: $input) {
            history {
                periods {
                    period
                    totalAmountMilliUsd
                    totalPayoutCount
                    totalSubscriptionCount
                    countryBreakdown {
                        countryCode
                        amountMilliUsd
                        payoutCount
                        subscriptionCount
                    }
                }
                cursor
            }
        }
    }
`;
